import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import IComponent from '../../../../services/forms.interface';
import TextField from "@mui/material/TextField";
import myxss from './myxss';
import MaskedTextInput from './masked-textinput';
import styled from '@emotion/styled';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';

interface ICustomProps {
    name: string;
    type: string;
    value: string;
    defaultValue: string;
    disabled: boolean;
    read_only: string;
    required: boolean;
    maskKey: string;
    error: any;
    onChange: any;
    onBlur: any;
    label: string;
    autoComplete: string;
}

const useStyles = makeStyles((theme) => ({
    formControl: {
        width: '100%'
    },
    textField: {
        width: '100%',
    },
    autoTextField: {
        width: '100%',
        padding: '0px 0px 5px 0px',
    },
}));

const StyledTextField = styled(TextField)({
    '& .MuiOutlinedInput-root': {
        backgroundColor: '#F9F9F9',
    },
});

const TextInput: React.FC<IComponent> = props => {
    const classes = useStyles();

    const handleChange = (event) => {
        props.handleChange(event, props.id, event.target.value);
    };

    const handleSelection = (event, value) => {
        props.handleChange(event, props.id, value);
    };

    const isRequired = (props.hasOwnProperty('required') && props.required === true && !props.read_only);
    const labelText = myxss.process(props.label);
    const localProps: ICustomProps = {} as ICustomProps;

    localProps.type = 'text';
    localProps.name = props.name;
    localProps.onChange = handleChange;
    localProps.required = isRequired;
    localProps.value = props.value? props.value: '';
    localProps.label = labelText;
    localProps.disabled = props.disabled;
    localProps.autoComplete = props.autocomplete;

    if (props.error) { localProps.error = true; }

    if (props.disabled)
        localProps.disabled = true;

    let baseClasses = 'item SortableItem rfb-item';
    if (props.editMode) { baseClasses += ' is-editing'; }
    if (!props.editMode) { baseClasses += ' not-is-editing'; }
    if (props.selected) { baseClasses += ' selected'; }

    return (
        <div className={baseClasses}>

            {props.options?.length > 0 &&
                <Autocomplete
                onInputChange={(event, newInputValue) => {
                    handleSelection(event, newInputValue);
                }}
                options={props.options}
                getOptionLabel={(option) => option.text || ""}
                fullWidth
                autoHighlight
                renderInput={(params) => <StyledTextField variant="outlined" {...params} {...localProps} fullWidth inputProps={{ ...params.inputProps, autoComplete: 'new-password', className: classes.autoTextField }} margin="none" size="small" />}
                />
            }

            {(!props.options || props.options?.length === 0) && (!props.mask || props.mask?.length === 0 || props.mask === 'maskEmail') &&
                <StyledTextField variant="outlined" {...localProps} fullWidth InputProps={{ className: classes.textField }} margin="none" size="small" />
            }
            {(!props.options || props.options?.length === 0) && props.mask?.length > 0 && props.mask !== 'maskEmail' &&
                <MaskedTextInput id={props.id} name={props.name} error={props.error}  {...localProps} onChange={handleChange} className={classes.textField} size="small" maskKey={props.mask} label={props.label} />
            }

            
        </div>
    );
}


export default TextInput;



